import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_app = _resolveComponent("ion-app")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createBlock(_component_el_config_provider, { locale: _ctx.lang }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_app, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_router_outlet)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["locale"]))
}